
class PaymentsController {

    displayFeeSheetForm: boolean = false;
    displayInsuranceSubMenu: boolean = false;

    static $inject = ['applicationObservable', 'Auth', 'USAuPairs'];
    constructor(applicationObservable, private Auth, private USAuPairs) {

        // If the AP is in US
        if (Auth.user.usAccessToken && Auth.user.usAccessToken.length) {
            this.USAuPairs.canAupairExtend({
                aupairId: this.Auth.user.usAuPairId
            })
                .$promise
                .then((result) => {
                    this.displayInsuranceSubMenu = result.data.isOkToShowInsuranceSubMenu;
                });
        }

        applicationObservable.subscribe(applicationInstance => {
            // Don't display fee sheet for AFIS DE
            if (applicationInstance.agencyId == 1210) { 
                this.displayFeeSheetForm = false;
            } else {
                this.displayFeeSheetForm = applicationInstance.status == 'OLA' || (['AWA', 'TBM', 'PLC', 'ACT', 'INA'].includes(applicationInstance.status) && !applicationInstance.isFeeSheetDocExists);
            }

        });
    }        
}

angular
    .module('app')
    .controller('PaymentsController', PaymentsController);